import React from "react";
import "../../styles/ComponentsStyles/Universal/ScrollableCardTable.style.css";
import PropTypes from "prop-types";
const ScrollableCardTable = ({ thead = [], children }) => {
  return (
    <table
      style={{ overflowX: "hidden" }}
      className="scrollableTableForCards scroll-y"
    >
      <thead className="w-full">
        <tr>
          {thead &&
            thead.map((_headText) => {
              return (
                <th
                  className="poppins t-14"
                  style={{ width: `calc(100%/${thead.length})` }}
                >
                  {_headText}
                </th>
              );
            })}
        </tr>
      </thead>
      <tbody className="w-full h-full">{children}</tbody>
    </table>
  );
};

export default ScrollableCardTable;
ScrollableCardTable.propTyoes = {
  thead: PropTypes.array.isRequired,
};
